<app-modal title="Nouveau service Tick&Live Connect" size="md" closeLabel="Fermer" (closed)="annuler()">
  <div class="flex flex-col gap-5 pt-1">
    <app-form-field label="Nom du service" [required]="true">
      <app-input [formControl]="nom" [maxLength]="longueurs.nomService" />
      @if (formatInvalide()) {
        <span appFieldError>Lettres et chiffres uniquement (deviendra l'étiquette {{ nomSaisi().trim() }}:Env)</span>
      } @else if (dejaExistant()) {
        <span appFieldError>Ce service existe déjà : ajoutez vos lignes dans sa section</span>
      } @else {
        <span appFieldHint>Exemple : TempsReel — le service sera créé avec sa première ligne</span>
      }
    </app-form-field>

    <app-form-field label="Type de service">
      <!-- Segments égaux sur toute la largeur du champ -->
      <app-segmented-control
        class="flex! w-full! *:flex-1"
        [options]="optionsNature"
        [value]="nature()"
        (valueChange)="nature.set($event)"
        ariaLabel="Type de service"
      />
      @if (nature() === 'partenaire') {
        <span appFieldHint>Comme TempsReel : des partenaires, avec code interface et key database par client</span>
      } @else if (nature() === 'application') {
        <span appFieldHint>Comme Crm : des applications, avec l'accès et sa visibilité pour chaque client</span>
      } @else {
        <span appFieldHint>Comme VenteWeb : des fronts web, avec seulement l'accès à chaque client</span>
      }
    </app-form-field>
  </div>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!peutValider()" (click)="valider()">Créer</button>
  </div>
</app-modal>
